import React, { Component } from 'react'

import "../css/admin/AdminUsuarios.css";
import check from "../assets/check.svg";
import checkGreen from "../assets/check.png";
import changeView from "../assets/eye-fill.svg";
import equis from "../assets/eliminar.svg"
import SideBar from './adminComponents/SideBar';
import ModalSolicitudes from './adminComponents/ModalSolicitudes';
import HeaderAdmin from './adminComponents/HeaderAdmin';
import NavBarInfo from './adminComponents/NavBarInfo';
import Modal from './components/Modal';
import { ComponenteSpinner } from './adminComponents/ComponenteSpinner';
import { Navigate } from 'react-router-dom';
import axios from "axios";
/*import MaterialTable from "material-table";*/
import MaterialTableAdmin from './components/MaterialTableAdmin';
import Cookies from 'js-cookie';
import ModalAdminMensaje from './adminComponents/ModalAdminMensaje';
import jwt from 'jwt-decode'
import Visualizarpdf from "./components/Visualizarpdf";
import ModalXL from './components/ModalXL';
import Face from '@material-ui/icons/Face'
import BrandingWatermark from '@material-ui/icons/BrandingWatermark'
import Description from '@material-ui/icons/Description';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { memo } from 'react';



export class AdminSolicitudes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            valor_fitro:"no revisado",
            motivo: "",
            showmodalCopy:false,
            modalIsOpen: false,
            modalExitoso: {
                show: false,
                titulo: "",
                mensaje: ""
            },
            vistaImg:true,
            solicitudes: [],
            datosUsuario: {
                nombres: "",
                apellidos: "",
                identificacion: "",
                rol: ""
            },
            columnas: [
                {
                    title: "#",
                    field: "idsccesolicitud",
                },
                {
                    title: "Solicitante",
                    field:"infosolicitud",
                    render: rowData => {
                        var infoSolicitud = JSON.parse(rowData.infosolicitud)
                        return (`${infoSolicitud.nombres.split(" ")[0]} ${infoSolicitud.apellidos}`)
                    },
                },
                {
                    title: "Estado",
                    field: "estado",

                },
                {
                    title: "Motivo",
                    field: "motivo",

                }
            ],
            acciones: [
                rowData => ({
                    icon: 'visibility',
                    iconProps: { style: { color: "#767E9F" } },
                    onClick: (event, rowData) => this.abrirModalVerSolicitud(rowData)
                })
            ],
            verSolicitud: {
                id: 0,
                nombres: "",
                correo: "",
                identificacion: "",
                actividad: "",
                unidad: "",
                telefono: "",
                usuario_sugerido: "",
                alias_sugerido: "",
                estado: ""

            },
            loading: true,
            cerrarSesion: false,
            modalMensaje: false,
            mensajerechazo: "",
            showImgRostronCedula: {
                show: false,
                srcImg: "",
                isFace: false,
            },
            showImgAcuerdo: "",
            modalshowPdf: {
                show: false,
                srcPdf: "",
            },
            IsValid: {
                isValidRostro: 1,
                isValidCedula: 1,
                isValidAcuerdo: 1
            },
            activebuttonAcept:true,
            tipoArchivoCedula: "imagen",
        };

        this.abrirModalVerSolicitud = this.abrirModalVerSolicitud.bind(this);
        this.cerrarModalVerSolicitud = this.cerrarModalVerSolicitud.bind(this);

        this.abrirshowmodalCopy = this.abrirshowmodalCopy.bind(this);
        this.cerrarshowmodalCopy = this.cerrarshowmodalCopy.bind(this);

        this.abrirModalExitoso = this.abrirModalExitoso.bind(this);
        this.cerrarModalExitoso = this.cerrarModalExitoso.bind(this);

        this.abrirModalMensaje = this.abrirModalMensaje.bind(this);
        this.cerrarModalMensaje = this.cerrarModalMensaje.bind(this);

        this.abrirModalRostronCedula = this.abrirModalRostronCedula.bind(this);
        this.cerrarModalRostronCedula = this.cerrarModalRostronCedula.bind(this);

        this.abrirModalPdf = this.abrirModalPdf.bind(this);
        this.cerrarModalPdf = this.cerrarModalPdf.bind(this);

        this.abrirModalAcuerdo = this.abrirModalAcuerdo.bind(this);
        this.cerrarModalAcuerdo = this.cerrarModalAcuerdo.bind(this);

        this.activebuttonAcept = this.activebuttonAcept.bind(this);
        this.disabledbuttonAcept = this.disabledbuttonAcept.bind(this);

        this.mensajeChange = this.mensajeChange.bind(this);
    }

    activebuttonAcept() {
        this.setState({ activebuttonAcept: true });
    }

    disabledbuttonAcept() {
        this.setState({ activebuttonAcept: false });
    }

    abrirshowmodalCopy() {
        this.setState({ showmodalCopy: true });
    }

    cerrarshowmodalCopy() {
        this.setState({ showmodalCopy: false });
    }

    mensajeChange(event) {
        this.setState({ mensajerechazo: event.target.value });
    }

    abrirModalMensaje() {
        this.setState({
            modalMensaje: true,
        });
        
    }

    cerrarModalMensaje() {
        this.setState({
            modalMensaje: false,
            IsValid: {
                isValidRostro: 1,
                isValidCedula: 1,
                isValidAcuerdo: 1
            },
        });


    }

    abrirModalPdf(valor) {
        this.setState({
            modalshowPdf: {
                ...this.state.modalshowPdf,
                show: true,
                srcPdf: valor,
            }
        });
    }

    cerrarModalPdf() {
        this.setState({
            modalshowPdf: {
                srcPdf: "",
                show: false
            }
        });
        //console.log("cerrar modal " + this.state.modalExitoso);
    }

    typeOfDocument () {
        axios.get(`https://wsarchivos.espol.edu.ec/api/DspaceFile/GetMetadatos/${this.state.verSolicitud.codimgtarjeta}`)
            .then(response => {
               // console.log(this.state.vistaImg);
                if (response.data.mimeType === "application/pdf") {
                    ///console.log("pdf");
                    this.setState({
                        vistaImg: false
                    }, () => {
                        //console.log(this.state.vistaImg);
                    })
                } else {
                                           // console.log(this.state.vistaImg);

                }
            })
    }


    abrirModalRostronCedula(valor, isface) {
        //console.log(this.state.verSolicitud.codimgtarjeta);

        this.typeOfDocument();

        this.setState({
            showImgRostronCedula: {
                ...this.state.showImgRostronCedula,
                show: true,
                srcImg: valor,
                isFace: isface
            }
        });
       // console.log("presentar modal");
    }

    cerrarModalRostronCedula() {
        this.setState({
            showImgRostronCedula: {
                srcImg: "",
                show: false,
            },
            vistaImg: true,
        });
        //console.log("cerrar modal " + this.state.modalExitoso);
    }



    abrirModalAcuerdo() {
        this.setState({ showImgAcuerdo: true });
    }

    cerrarModalAcuerdo() {
        this.setState({ showImgAcuerdo: false });
    }




    abrirModalExitoso() {
        this.setState({
            modalExitoso: {
                ...this.state.modalExitoso,
                show: true
            }
        });
    }

    cerrarModalExitoso() {
        this.setState({
            modalExitoso: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
       // console.log("cerrar modal " + this.state.modalExitoso);
    }

    abrirModalVerSolicitud(rowData) {
        this.setState({ modalIsOpen: true });
        this.traerDatosSolicitud(rowData)
    }

    cerrarModalVerSolicitud() {
        this.setState({ modalIsOpen: false });
       // console.log("cerrar modal " + this.state.modalIsOpen);
    }

    traerDatosSolicitud = async (rowData) => {
        var infoSolicitud = JSON.parse(rowData.infosolicitud);
       // console.log(infoSolicitud);
       // console.log(rowData);
        await this.setState({
            verSolicitud: {
                id: rowData.idsccesolicitud,
                nombres: infoSolicitud.nombres,
                apellidos: infoSolicitud.apellidos,
                correo: infoSolicitud.correo,
                identificacion: infoSolicitud.identificacion,
                actividad: infoSolicitud.actividad,
                unidad: infoSolicitud.unidad,
                telefono: infoSolicitud.telefono,
                usuario_sugerido: infoSolicitud.usuario_sugerido,
                alias_sugerido: infoSolicitud.alias_sugerido,
                estado: rowData.estado,
                codimgcontrato: rowData.codimgcontrato,
                codimgpersona: rowData.codimgpersona,
                codimgtarjeta: rowData.codimgtarjeta,
                tipoacuerdo: rowData.tipoacuerdo,
            },
            motivo:rowData.motivo,  
        })
        //console.log(this.state.verSolicitud);
    }

    getSolicitudes = async () => {
        await axios.get(`${process.env.REACT_APP_API}api/Solicitud/getsolicitudFiltro/${this.state.valor_fitro}`)
            .then(response => {
                //console.log("se ejecuta get solicitudes. Response.data:");
                //console.log(response.data);
                this.setState(
                    {
                    solicitudes: response.data,
                        loading: false
                    }
                )
            })
            .catch(error => {
                    //console.log(error.request);
                    console.log("status:", error.response?.status);
                    console.log("data:", error.response?.data);
                    console.log("headers:", error.response?.headers);

                    this.setState({
                        modalExitoso: {
                            show: true,
                            imagen: equis,
                            titulo: "Error en la solicitud",
                            mensaje: error.request.response || error.response?.data || error.message ||"Error desconocido"
                        }
                    });
            })
    }



    HabilitarCuentaSA = async (e) => {
       // console.log("habilitar en cas");
        e.preventDefault();
        var identificacion = this.state.verSolicitud.identificacion;
       // console.log(identificacion);
        //console.log(this.state.verSolicitud.id);
        await axios.post(`${process.env.REACT_APP_API}api/Persona/enableaccountSA/${identificacion}/${this.state.verSolicitud.id}`)
                .then(resp => {
                    //console.log(resp);
                    if(resp.data==="Se habilito la cuenta"){
                        this.cerrarModalVerSolicitud();
                        this.setState({
                            modalExitoso: {
                                show: true,
                                imagen: checkGreen,
                                titulo: "Cuenta Habilitada",
                                mensaje: `La cuenta ${this.state.verSolicitud.usuario_sugerido} del servicio activo ha sido habilitada.`
                            }
                        });
                        this.getSolicitudes();
                    }
                }).catch(error => {
                    //console.log(error.request);
                    console.log("status:", error.response?.status);
                    console.log("data:", error.response?.data);
                    console.log("headers:", error.response?.headers);

                    this.setState({
                        modalExitoso: {
                            show: true,
                            imagen: equis,
                            titulo: "Error en la solicitud",
                            mensaje: error.request.response || error.response?.data || error.message ||"Error desconocido"
                        }
                    })
                
                });
    }

    rostrostatus = (e) => {
        var i = 0;
        if (!e.target.checked) {
            i = 1;
        }
        this.setState({
            IsValid: {
                ...this.state.IsValid,
                isValidRostro: i,
            }
        })
    }



    cedulatatus = (e) => {
        var i = 0;
        if (!e.target.checked) {
            i = 1;
        }
        this.setState({
            IsValid: {
                ...this.state.IsValid,
                isValidCedula: i,
            }
        })
    }

    acuerdostatus = (e) => {
        var i = 0;
        if (!e.target.checked) {
            i = 1;
        }
        this.setState({
            IsValid: {
                ...this.state.IsValid,
                isValidAcuerdo: i,
            }
        })
    }

   

    postAceptarSolicitud = async (e) => {

        e.preventDefault();
        var idSolicitud = this.state.verSolicitud.id;
        var infoSolicitud = this.state.verSolicitud;
        var solicitud = {};
        //console.log(this.state.verSolicitud.estado);
        //this.state.verSolicitud.codimgcontrato
        if (this.state.verSolicitud.estado === "No Revisado CC") {
            //const inicio = performance.now();

           // console.log("solicitud no revisada cc");
            /*await this.setState({
                verSolicitud: {
                    ...this.state.verSolicitud,
                    estado: "Aceptado"
                }
            });*/
           // var estado = this.state.verSolicitud.estado;

            solicitud = {
                estado: "Aceptado",
                infoSolicitud: JSON.stringify(infoSolicitud),
                Motivo: "Solicitud CC aceptada de manera manual por el Administrador.",
                Identificacion: this.state.verSolicitud.identificacion,
                isvalidcontrato: 1,
                isvalidimgpersona: 1,
                isvalidimgtarjeta:1
            }
            //console.log(solicitud);
            //const inicio1 = performance.now();
            await axios.put(`${process.env.REACT_APP_API}api/Solicitud/putasynccc/${idSolicitud}`, solicitud)
                .then(resp => {
                    this.cerrarModalVerSolicitud();
                    this.setState({
                        modalExitoso: {
                            show: true,
                            imagen: check,
                            titulo: "Solicitud Aceptada",
                            mensaje: "La solicitud ha sido aceptada de forma exitosa"
                        }
                    })
                   // this.getSolicitudes();
                    //onsole.log(this.state.solicitudes);
                    const nuevoArreglo = this.state.solicitudes.filter(objeto => objeto.identificacion != this.state.verSolicitud.identificacion);
                    this.setState({ solicitudes: nuevoArreglo });
                   // console.log("actualización de solicitudes");
                }).catch(error => {
                    if (error.request.response === "") {
                        this.setState({
                            modalExitoso: {
                                show: true,
                                imagen: equis,
                                titulo: "Error en la solicitud",
                                mensaje: "Error en la solicitud, intentelo mas tarde"
                            }
                        })
                    } else {
                        this.setState({
                            modalExitoso: {
                                show: true,
                                imagen: equis,
                                titulo: "Error en la solicitud",
                                mensaje: error.response.data.errorMessage
                            }
                        })
                    }

                });
            //const fin1 = performance.now();
            //const tiempoTranscurrido1 = fin1 - inicio1;
            //console.log("tiempo solo del endpoint> "+tiempoTranscurrido1);
            //const fin = performance.now();
            //const tiempoTranscurrido = fin - inicio;
            //console.log("tiempo de la funcion dentro del if> " + tiempoTranscurrido);
        } else {
            await this.setState({
                verSolicitud: {
                    ...this.state.verSolicitud,
                    estado: "Aceptado"
                }
            });
            var estado = this.state.verSolicitud.estado;

            solicitud = {
                estado: estado,
                infoSolicitud: JSON.stringify(infoSolicitud),
                Motivo: "Solicitud aceptada de manera manual por el Administrador.",
                Identificacion: this.state.verSolicitud.identificacion
            }


            
            await axios.put(`${process.env.REACT_APP_API}api/Solicitud/${idSolicitud}`, solicitud) //PutAsync
                .then(resp => {
                    this.cerrarModalVerSolicitud();
                    this.setState({
                        modalExitoso: {
                            show: true,
                            imagen: check,
                            titulo: "Solicitud Aceptada",
                            mensaje: "La solicitud ha sido aceptada de forma exitosa"
                        }
                    })
                    //this.getSolicitudes();
                    /*console.log(this.state.solicitudes);
                    const nuevoArreglo = this.state.solicitudes.filter(objeto => objeto.identificacion !=== this.state.verSolicitud.identificacion);
                    this.setState({ solicitudes: nuevoArreglo });*/
                }).catch(error => {

                    if (error.request.response === "") {
                        this.setState({
                            modalExitoso: {
                                show: true,
                                imagen: equis,
                                titulo: "Error en la solicitud",
                                mensaje: "Error en la solicitud, intentelo mas tarde"
                            }
                        })
                    } else {
                        if (error.response.data.errorMessage === "Esta identificacion ya se encuentra registrada") {
                            this.setState({
                                modalExitoso: {
                                    show: true,
                                    imagen: equis,
                                    titulo: "Error en la solicitud",
                                    mensaje: error.response.data.errorMessage
                                }
                            })
                        } else if (error.response.data.errorMessage === "Nombres de usuario o alias ya existentes") {
                            this.setState({
                                modalExitoso: {
                                    show: true,
                                    imagen: equis,
                                    titulo: "Error en la solicitud",
                                    mensaje: error.response.data.errorMessage
                                }
                            })
                        } else {
                            this.setState({
                                modalExitoso: {
                                    show: true,
                                    imagen: equis,
                                    titulo: "Error en la solicitud",
                                    mensaje: error.response.data.errorMessage
                                }
                            })
                        }
                    }
                });
        }
       

    }


    copyToClipboard = () => {
        axios.get(`${process.env.REACT_APP_API}api/Solicitud/getTokenToReplaceDocs/${this.state.verSolicitud.usuario_sugerido}/${this.state.verSolicitud.nombres}/${this.state.verSolicitud.apellidos}/${this.state.verSolicitud.actividad}`)
            .then(r => {
                if (r.status === 200) {
                    this.setState({
                        url_clipboard: r.data 
                    }, () => {
                        navigator.clipboard.writeText(r.data);
                        this.abrirshowmodalCopy();
                    })
                }
            })
            .catch(error => {

            })
    }


    postRechazarSolicitud = async (e) => { 
        e.preventDefault();
        this.disabledbuttonAcept();
        this.abrirModalMensaje();
        
        var idSolicitud = this.state.verSolicitud.id;
        var infoSolicitud = this.state.verSolicitud;
        //console.log(this.state.verSolicitud.estado);
        if (this.state.verSolicitud.estado === "No Revisado CC" || this.state.verSolicitud.estado === "Rechazado CC") {
            await this.setState({
                verSolicitud: {
                    ...this.state.verSolicitud,
                    estado: "Rechazado CC"
                }
            });
            var estado = this.state.verSolicitud.estado;
            var solicitud = {
                estado: estado,
                infoSolicitud: JSON.stringify(infoSolicitud),
                Motivo: this.state.mensajerechazo,
                Identificacion: this.state.verSolicitud.identificacion,
                isvalidimgpersona: this.state.IsValid.isValidRostro,
                isvalidimgtarjeta: this.state.IsValid.isValidCedula,
                isvalidcontrato: this.state.IsValid.isValidAcuerdo, 
            }
            //console.log("rechazo cc", solicitud);
            await axios.put(`${process.env.REACT_APP_API}api/Solicitud/putasynccc/${idSolicitud}`, solicitud)
                .then(resp => {
                    this.activebuttonAcept();

                //console.log("post solicitud rechazada y se bloquea la cuenta");
                //console.log(solicitud);
                this.cerrarModalVerSolicitud();
                this.cerrarModalMensaje();
                this.setState({
                    modalExitoso: {
                        show: true,
                        imagen: check,
                        titulo: "Solicitud Rechazada",
                        mensaje: "La solicitud ha sido rechazada de forma exitosa"
                    }
                })
                this.getSolicitudes();
                }).catch(error => {
                    this.disabledbuttonAcept();
               // console.log(error.message);
            })
        } else {
            await this.setState({
                verSolicitud: {
                    ...this.state.verSolicitud,
                    estado: "Rechazado"
                }
            })
            var estado = this.state.verSolicitud.estado;
            var solicitud = {
                estado: estado,
                infoSolicitud: JSON.stringify(infoSolicitud),
                Motivo: this.state.mensajerechazo,
                Identificacion: this.state.verSolicitud.identificacion,
            }

            await axios.put(`${process.env.REACT_APP_API}api/Solicitud/${idSolicitud}`, solicitud)
                .then(resp => {
                   // console.log("post solicitud rechazada");
                    //console.log(solicitud);
                    this.cerrarModalVerSolicitud();
                    this.cerrarModalMensaje();
                    this.setState({
                        modalExitoso: {
                            show: true,
                            imagen: check,
                            titulo: "Solicitud Rechazada",
                            mensaje: "La solicitud ha sido rechazada de forma exitosa"
                        }
                    })
                    this.getSolicitudes();
                }).catch(error => {
                    //console.log(error.message);
                })


        }

    }

    cerrarSesion = async () => {
        this.props.setValue(false);
        Cookies.remove("nombres");
        Cookies.remove("apellidos");
        Cookies.remove("identificacion");
        Cookies.remove("token");
        Cookies.remove("cas");

        Cookies.remove("rol");
        Cookies.remove("username");
      Cookies.remove("DatosPersonalesGIA.CAS");
        Cookies.remove("id");
        Cookies.remove("correoAlterno");
        Cookies.remove("Nombre");
     
      window.location.href = "/logout"
      this.setState({ cerrarSesion: true });
      //  console.log("cerrando sesion");
    }


    setearHeader() {
        //console.log("setear header");
        var token = Cookies.get("token")
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            axios.defaults.headers.common['Authorization'] = null;
        }
    }


    componentDidMount() {
        var token = Cookies.get("token");
        var tokendecode = jwt(token);
        this.state.datosUsuario.nombres = tokendecode["Nombres"];
        this.state.datosUsuario.apellidos = tokendecode["Apellidos"];
        this.state.datosUsuario.rol = tokendecode["Rol"];
        if(this.state.datosUsuario.rol != "Admin" ){
            window.location.href = "/inicio"
        }
        this.setState({
            datosUsuario: {
                nombres: tokendecode["Nombres"],
                apellidos: tokendecode["Apellidos"],
            }
        });
        this.setearHeader();
        this.getSolicitudes();
    }

    change_filter_solicitud (filtro) {
       // console.log(filtro); 
        this.setState({
            valor_fitro: filtro
        }, () => { this.getSolicitudes() })
    }

    render() {
       //console.log("render de admin solicitudes"); 

        var nombresCompletos = `${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`
        var identificacion = this.state.datosUsuario.identificacion;
        return (
            this.state.cerrarSesion ? <Navigate to="/Inicio" /> :
                this.state.loading ?
                    <ComponenteSpinner></ComponenteSpinner> :
                    (<div id="admin-fondo">
                        <HeaderAdmin nombresCompletos={nombresCompletos}></HeaderAdmin>
                        <NavBarInfo cerrarSesion={this.cerrarSesion}></NavBarInfo>
                        <div className='row adminUsers-body'>
                            <SideBar nombres={nombresCompletos} cedula={identificacion} tipo={"solicitudes"}></SideBar>
                            <div className='col-md-9 mt-4'>
                                <p className='admin-titulo'>Solicitudes</p>
                                <div className="row contendor_btn_filtro_solicitud">
                                    <div className="col-md-4 col-sm-4 item_filtro_solicitud">
                                        <button onClick={() => this.change_filter_solicitud("aceptado")} className=" pb-6">
                                            ACEPTADOS
                                        </button>
                                    </div>
                                    <div className="col-md-4 col-sm-4 item_filtro_solicitud">
                                        <button onClick={() => this.change_filter_solicitud("rechazado")} className=" pb-6">
                                            RECHAZADOS
                                        </button>
                                    </div>
                                    <div className="col-md-4 col-sm-4 item_filtro_solicitud">
                                        <button onClick={() => this.change_filter_solicitud("no revisado")} className=" pb-6">
                                            NO REVISADOS
                                        </button>
                                    </div>
                                </div>
                                {/** 
                                    <MaterialTable
                                        title=""
                                        columns={this.state.columnas}
                                        data={this.state.solicitudes}
                                        actions={this.state.acciones}
                                        options={{
                                            actionsColumnIndex: -1,
                                            pageSize: 10,
                                            pageSizeOptions: [10, 20, 40, 60],
                                            headerStyle: { backgroundColor: '#767E9F', color: 'white', fontWeight: 'bold', zIndex: 0, paddingRight: '50px' }
                                        }}
                                        localization={{
                                            header: { actions: "Acciones" },
                                            toolbar: { searchPlaceholder: 'Filtrar' },
                                            pagination: { labelRowsSelect: "Filas" },
                                        }}
                                    > </MaterialTable>
                                **/}
                                <MaterialTableAdmin
                                    columns={this.state.columnas}
                                    data={this.state.solicitudes}
                                    actions={this.state.acciones}
                                > </MaterialTableAdmin>
                            </div>
                        </div>


                        {this.state.modalIsOpen &&
                            <ModalSolicitudes
                                isOpen={this.state.modalIsOpen}
                                cerrarModal={this.cerrarModalVerSolicitud}
                                tituloHeader="DATOS DE SOLICITUD"
                                submit={this.postAceptarSolicitud}
                                cancel={this.abrirModalMensaje}
                                enable={this.HabilitarCuentaSA}
                                txtBtnSubmit={"ACEPTAR"}
                                txtBtnCancel={"RECHAZAR"}
                                txtBtnEnable={"HABILITAR"}
                                estado={this.state.verSolicitud.estado}
                                motivo={this.state.motivo}
                            >
                                <form>
                                    <div className="row mt-2">
                                        <label className='col-sm-4 col-form-label' htmlFor='nombres' id="modalSolicitudes-texto">Nombres: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control" type="text" name="nombres" defaultValue={this.state.verSolicitud.nombres} disabled></input>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label className='col-sm-4 col-form-label' htmlFor="apellidos" id="modalSolicitudes-texto">Apellidos: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control" type="text" name="apellidos" defaultValue={this.state.verSolicitud.apellidos} disabled></input>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label className='col-sm-4 col-form-label' htmlFor="alias_sugerido" id="modalSolicitudes-texto">Alias: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control" type="text" name="alias_sugerido" defaultValue={this.state.verSolicitud.alias_sugerido} disabled></input>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label className='col-sm-4 col-form-label' htmlFor="correo" id="modalSolicitudes-texto">Correo alterno: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control" type="text" name="correo" defaultValue={this.state.verSolicitud.correo} disabled></input>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label className='col-sm-4 col-form-label' htmlFor="identificacion" id="modalSolicitudes-texto">Cédula: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control" type="text" name="identificacion" defaultValue={this.state.verSolicitud.identificacion} disabled></input>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label className='col-sm-4 col-form-label' htmlFor="actividad" id="modalSolicitudes-texto">Actividad: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control" type="text" name="actividad" defaultValue={this.state.verSolicitud.actividad} disabled></input>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label className='col-sm-4 col-form-label' htmlFor="unidad" id="modalSolicitudes-texto">Unidad: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control" type="text" name="unidad" defaultValue={this.state.verSolicitud.unidad} disabled></input>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label className='col-sm-4 col-form-label' htmlFor="telefono" id="modalSolicitudes-texto">Teléfono: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control" type="text" name="telefono" defaultValue={this.state.verSolicitud.telefono} disabled></input>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label className='col-sm-4 col-form-label' htmlFor="usuario_sugerido" id="modalSolicitudes-texto">Usuario: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control" type="text" name="usuario_sugerido" defaultValue={this.state.verSolicitud.usuario_sugerido} disabled></input>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <label className='col-sm-2 col-form-label' htmlFor="usuario_sugerido" id="modalSolicitudes-texto">Media: </label>





                                        {this.state.verSolicitud.codimgpersona && (
                                            <div className="col-sm-2 text-center">
                                                <label align="center" className=' col-form-label'>
                                                    <button type="button" title="Rostro" className="admsol-btn-media" onClick={() => this.abrirModalRostronCedula(this.state.verSolicitud.codimgpersona, true)}><Face /></button>
                                                </label>
                                            </div>
                                        )}

                                        {this.state.verSolicitud.codimgtarjeta && (
                                            <div className="col-sm-2 text-center">
                                                <label align="center" className=' col-form-label'>
                                                    <button type="button" title="Identificación" className="admsol-btn-media" onClick={() => this.abrirModalRostronCedula(this.state.verSolicitud.codimgtarjeta, false)}><BrandingWatermark /></button>
                                                </label>
                                            </div>
                                        )}

                                        {this.state.verSolicitud.codimgcontrato && this.state.verSolicitud.codimgtarjeta && (

                                            <div className="col-sm-2 text-center">
                                                <label align="center" className=' col-form-label'>
                                                    <button type="button" title="Acuerdo" className="admsol-btn-media" onClick={() => this.abrirModalPdf(this.state.verSolicitud.codimgcontrato)}><Description /></button>
                                                </label>
                                            </div>
                                        )}
                                        {this.state.verSolicitud.codimgcontrato && !this.state.verSolicitud.codimgtarjeta && (

                                            <div className="col-sm-2 text-center">
                                                <label align="center" className=' col-form-label'>
                                                    <button type="button" title="Acuerdo Digital" className="admsol-btn-media" onClick={() => this.abrirModalPdf(this.state.verSolicitud.codimgcontrato)}><Description /></button>
                                                </label>
                                            </div>
                                        )}
                                        {this.state.verSolicitud.estado === "Rechazado CC" &&
                                            <div className="col-sm-2 text-center">
                                                <label align="center" className=' col-form-label'>
                                                    <button type="button" title="Copiar token" className="admsol-btn-media" onClick={() => this.copyToClipboard()}><FileCopyIcon /></button>
                                                </label>
                                            </div>

                                        }
                                    </div>

                                </form>
                            </ModalSolicitudes>}

                        {this.state.modalMensaje &&
                            <ModalAdminMensaje
                                isOpen={this.state.modalMensaje}
                                cerrarModal={this.cerrarModalMensaje}//activebutton
                                txtBtnSubmit="ENVIAR"
                                txtBtnCancel="CANCELAR"
                                submit={this.postRechazarSolicitud}
                                activebuttonAcept={this.state.activebuttonAcept}                            >
                               
                                <h4 className='text-center'><strong>Solicitud Rechazada</strong></h4>
                                <div className='mt-6 mb-6' align="center">
                                    <img className="admin-check" src={equis} alt="Eliminar"></img>
                                </div>
                                <p className='text-center'><strong>Ingrese la razón del Rechazo</strong></p>
                                <textarea value={this.state.mensajerechazo} onChange={this.mensajeChange} className='textarea-center' ></textarea>
                                <p className='text-center letter-size'><b>*Esta acción no podrá deshacerse</b></p>

                                <p className='text-center'><strong>¿Qué documento está incorrecto?</strong></p>
                                <div className="row">
                                    <div className="col-md-4">
                                        <p className='text-center input'><input className="form-check-input"
                                            type="checkbox" name="rostro" 
                                            id="rostro" value={this.state.IsValid.v}
                                            onClick={this.rostrostatus}
                                        /> ROSTRO</p>
                                    </div>
                                    <div className="col-md-4">
                                        <p className='text-center input'><input className="form-check-input"
                                            type="checkbox" name="cedula"
                                            id="cedula" value={this.state.IsValid.isValidCedula}
                                            onClick={this.cedulatatus}
                                        /> CÉDULA</p>
                                    </div>
                                    <div className="col-md-4">
                                        <p className='text-center input'><input className="form-check-input"
                                            type="checkbox" name="acuerdo"
                                            id="acuerdo" value={this.state.IsValid.isValidAcuerdo}
                                            onClick={this.acuerdostatus}
                                        /> ACUERDO</p>
                                    </div>
                                </div>


                            </ModalAdminMensaje>
                        }

                        {this.state.modalExitoso.show &&
                            <Modal isOpen={this.state.modalExitoso.show} cerrarModal={this.cerrarModalExitoso} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>{this.state.modalExitoso.titulo}</strong></p>
                                <div className='mt-6 mb-6' align="center">
                                    <img className="registroContra-check" src={this.state.modalExitoso.imagen} alt="Exitoso"></img>
                                </div>

                                <p className='text-center'>{this.state.modalExitoso.mensaje}</p>
                            </Modal>}

                        {this.state.modalExitoso.show &&
                            <Modal isOpen={this.state.modalExitoso.show} cerrarModal={this.cerrarModalExitoso} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>{this.state.modalExitoso.titulo}</strong></p>
                                <div className='mt-6 mb-6' align="center">
                                    <img className="registroContra-check" src={this.state.modalExitoso.imagen} alt="Exitoso"></img>
                                </div>

                                <p className='text-center'>{this.state.modalExitoso.mensaje}</p>
                            </Modal>}

                        {this.state.showImgRostronCedula.show &&
                            <ModalXL isOpen={this.state.showImgRostronCedula.show} cerrarModal={this.cerrarModalRostronCedula} verBoton={false} textoBoton="ACEPTAR" >
                                {this.state.showImgRostronCedula.isFace ?
                                    <>
                                        <h3 className='text-center '><strong>Foto del Rostro</strong></h3>
                                        <div className='mt-6 mb-6' align="center">
                                            <img className="admsol-modal-img" src={`https://wsarchivos.espol.edu.ec/api/DspaceFile/DownloadDspace/${this.state.showImgRostronCedula.srcImg}/rostro.jpg`} alt="Exitoso"></img>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <h3 className='text-center'><strong>Foto de la Cédula</strong></h3>
                                        {this.state.vistaImg &&
                                            <div className='mt-6 mb-6' align="center">
                                                <img className="admsol-modal-img" src={`https://wsarchivos.espol.edu.ec/api/DspaceFile/DownloadDspace/${this.state.showImgRostronCedula.srcImg}/doc_identidad.jpg`} alt="Exitoso"></img>
                                            </div>
                                        }
                                        {!this.state.vistaImg &&
                                            <Visualizarpdf  pathpdf={`https://wsarchivos.espol.edu.ec/api/DspaceFile/DownloadDspace/${this.state.showImgRostronCedula.srcImg}/Firma_manual_acumed.pdf`} />
                                         }
                                    </>
                                }


                                <div className="modal-container-botonGuardar">
                                    {/*<button className='admsol-modal-btn' onClick={this.cerrarModalRostronCedula}>ACEPTAR</button>*/}
                                </div>
                            </ModalXL>
                        }
                        {
                            this.state.modalshowPdf.show &&
                            <ModalXL modalXXL={true} isOpen={this.state.modalshowPdf.show} cerrarModal={this.cerrarModalPdf} verBoton={false}  >
                                <Visualizarpdf titulo={"ACUERDO FIRMADO"} pathpdf={`https://wsarchivos.espol.edu.ec/api/DspaceFile/DownloadDspace/${this.state.modalshowPdf.srcPdf}/Firma_manual_acumed.pdf`} />
                                <div className="modalXXL-container-botonGuardar">
                                    {/*<button className='admsol-modalXXL-btn' onClick={this.cerrarModalPdf}>ACEPTAR</button>*/}
                                </div>
                            </ModalXL>
                        }

                        {this.state.showmodalCopy &&
                            <Modal isOpen={this.state.showmodalCopy} cerrarModal={this.cerrarshowmodalCopy} verBoton={false} textoBoton="ACEPTAR" >
                                    <div>
                                        <h3 className='text-center '><strong>Se copio el enlace para que el usuario suba los documentos con errores.</strong></h3>
                                       
                               
                              
                                 <div className="modal-container-botonGuardar">
                                    <button className='admsol-modal-btn' onClick={this.cerrarshowmodalCopy}>ACEPTAR</button>
                                    </div>
                                </div>
                            </Modal>
                        }


                    </div>)
        )
    }
}

export default memo(AdminSolicitudes)
